import { all } from "redux-saga/effects"

import loginSaga from "./login/saga"

function* userSaga() {
  yield all([loginSaga()])
}

export default userSaga
